import { IGetSearchSoilRequestModel,IAddEditSoilRequestModel,IDeleteSoilRequestModel } from './requestType';


export const initGetSearchSoilRequestModel:IGetSearchSoilRequestModel = {
    isForTableView: false,
    isAnalysis: true,
    analysis: {
        intSampleID: 0,
        strAnalysesIDs: '',
        description: '',
        requestedby: '',
        analysedby: '',
        strUserID: '',
        contributor: '',
        uploadDate: '',
        strSearch: '',
        sortCol: '',
        order: '',
        pageIndex: 0,
        pageSize: 0,
        strDate: '',
        strStatus: '',
    },
    profile: {
        profileID: 0,
        profileCode: '',
        searchString: '',
        countryCode: '',
        strType: '',
    },
    coordinate: {
        areaIDs: '',
        polygon: '',
        searchRadius: 0,
        propertiesIDs: '',
        isSplitByCountry: true,
        strSearchCoordinates: '',
        coordinates: [
            {
                locationName: '',
                lat: 0,
                lng: 0
            }
        ]
    }
};

export const initAddEditSoilRequestModel:IAddEditSoilRequestModel = {
    addEditFlag: 0,
    analysis: {
        layerid: 0,
        description: '',
        requestedby: '',
        analysedby: '',
        userID: '',
        contributor: '',
        // propertyMeasurements: [
        //     {
        //         propMeasureId: 0,
        //         propValue: '',
        //     }
        // ],
        propertyMeasurements: null,
        uploadDate: ''
    },
    profile: {
        profileid: 0,
        profileName: '',
        profileDesc: '',
        lat: 0,
        lng: 0,
        fieldType: 0,
        publisher: '',
        contributor: '',
        layerDetails: [
            {
                layerID: 0,
                layer: '',
                rank: 0,
                startDepth: 0,
                endDepth: 0,
                thickness: '',
                method: 0,
            }
        ],
        isStandard: true,
        extrefID: 0,
        extObject: '',
        placeName: '',
        countryCode: '',
        adminName1: ''
    },
    sample: {
        sampleid: 0,
        sampleDate: '',
        sampleDepth: 0,
        sampleEndDepth: 0,
        sampleInternalID: '',
        sampleExternalRef: '',
        sampleStatusID: 0
    }
};

export const initDeleteSoilRequestModel:IDeleteSoilRequestModel = {
    analysis: {
        strAnalysesIDs: ''
    },
    layer: {
        strLayerIDs: ''
    },
    profile: {
        strProfileIDs: ''
    }
};